"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrChat = void 0;
const react_1 = __importDefault(require("react"));
const react_olark_plugin_1 = __importDefault(require("react-olark-plugin"));
const components_common_lazy_render_1 = require("@hotelplan/components.common.lazy-render");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_chat_mappers_1 = require("./fdr-chat.mappers");
const fdr_chat_utils_1 = require("./fdr-chat.utils");
const useChatEventListeners_1 = require("./useChatEventListeners");
const useOlarkLocalConfig_1 = require("./useOlarkLocalConfig");
const useOlarkTracking_1 = require("./useOlarkTracking");
const useVisitorDetails_1 = __importDefault(require("./useVisitorDetails"));
const FdrChat = ({ id, personalData, systemConfig, }) => {
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(() => {
        (0, fdr_chat_utils_1.hideChatBox)();
        window.olark(fdr_chat_utils_1.CHAT_ON_SHRINK, fdr_chat_utils_1.hideChatBox);
    }, []);
    (0, useOlarkTracking_1.useOlarkTracking)();
    (0, useChatEventListeners_1.useChatEventListeners)();
    (0, useVisitorDetails_1.default)((0, fdr_chat_mappers_1.mapAccountPersonalDataResponseToVisitorDetails)(personalData));
    const localeConfig = (0, useOlarkLocalConfig_1.useOlarkLocalConfig)();
    return (react_1.default.createElement(react_olark_plugin_1.default, { siteId: id, systemConfig: Object.assign({ hb_disable_mobile: false, hb_show_as_tab: false, group: '2ef1044f53c1e902739ff47e786cec64' }, systemConfig), localeConfig: localeConfig }));
};
exports.FdrChat = FdrChat;
exports.default = (0, components_common_lazy_render_1.withLazyHydrate)(exports.FdrChat, {
    whenIdle: true,
    noWrapper: true,
});
//# sourceMappingURL=fdr-chat.js.map